import { PayWith } from "./PayWith";
import "../assets/css/Footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <PayWith></PayWith>
      <h4>© 2022 TRUE STORE COPYRIGHT. ALL RIGHTS RESERVED.</h4>
    </div>
  );
}
